import { NgModule } from "@angular/core";
import { JwtHelperService, JWT_OPTIONS } from "@auth0/angular-jwt";
import { TranslateModule } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { LoaderComponent } from './components/loader/loader.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogModule } from "primeng/dialog";
import { NotificationFeedComponent } from "../notification-feed/notification-feed.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChatPopupComponent } from "./components/chat-popup/chat-popup.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DataTableComponent } from "./components/data-table/data-table.component";
import { StatusBadgeComponent } from "./components/status-badge/status-badge.component";
import { MultiSelectFilterComponent } from "./components/data-table/multi-select-filter/multi-select-filter.component";
import { ColumnFilterDropdownComponent } from "./components/data-table/column-filter-dropdown/column-filter-dropdown.component";
import { TableModule } from "primeng/table";
import { MobileInputComponent } from "./components/mobile-input/mobile-input.component";
import { RequiredFieldDirective } from "./helpers/required-field.directive";
import { MatDialogModule } from "@angular/material/dialog";
import { SharedOTPDialogComponent } from "./components/shared-otp-dialog/shared-otp-dialog.component";
import { AutoTabDirective } from "./helpers/auto-tab.directive";
import { ToastrModule } from 'ngx-toastr';
import { CommonModule } from "@angular/common";

@NgModule({
  imports: [
    CommonModule,
    DialogModule,
    TranslateModule,
    MatTooltipModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    TableModule,
  ],
  exports: [
    CommonModule,
    LoaderComponent,
    DialogComponent,
    NotificationFeedComponent,
    ChatPopupComponent,
    MobileInputComponent,
    RequiredFieldDirective,
    SharedOTPDialogComponent,
    ToastrModule,
    AutoTabDirective,
    DataTableComponent,
    StatusBadgeComponent,
    MultiSelectFilterComponent,
    ColumnFilterDropdownComponent,
    ReactiveFormsModule,
    FormsModule,
  ],
  declarations: [
    LoaderComponent,
    DialogComponent,
    NotificationFeedComponent,
    ChatPopupComponent,
    MobileInputComponent,
    RequiredFieldDirective,
    SharedOTPDialogComponent,
    AutoTabDirective,
    DataTableComponent,
    StatusBadgeComponent,
    MultiSelectFilterComponent,
    ColumnFilterDropdownComponent,
  ],
  providers: [
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS }, JwtHelperService,
    MessageService,
  ]
})
export class SharedModule {}